import Api from '@common/services/api';

export type evaluationPayload = {
  submission_status: string;
  response: [
    {
      component_id: string;
      answer: string;
    },
    {
      component_id: string;
      answer: {
        competency_id: string;
        scale_id: string;
        comment: string;
      };
    }
  ];
};

export const updateEvaluation = async (
  organisationId: string,
  evaluationId: string,
  payload: evaluationPayload
) => {
  const result = await Api.put(
    `/v1/organisations/${organisationId}/performance/evaluations/${evaluationId}`,
    payload
  );

  return result;
};
